export default {
  title: 'Rewards have changed for this sale',
  subTitle:
    'Changes have been made to this sale, so some rewards may have changed or become unavailable.',
  continue: 'Continue',
  returnToCurrentSale: 'Return to current sale',
}
